import React from 'react';
import './BarLoader.css';

const BarLoader: React.FC<any> = (props: any) => (
  <div className="bar-loader"  {...props}></div>
);

export default BarLoader;
